import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const DEV_OVERRIDE = false;

const DevOfflineOverrideContext = createContext({
  enabled: false,
  devIsOffline: false,
  setDevIsOffline: () => {},
});

export const useDevOfflineOverride = () =>
  useContext(DevOfflineOverrideContext);

export function DevOfflineOverrideProvider({ children }) {
  const [devIsOffline, setDevIsOffline] = useState(false);

  const value = useMemo(
    () => ({
      enabled: DEV_OVERRIDE,
      devIsOffline,
      setDevIsOffline,
    }),
    [devIsOffline]
  );

  return (
    <DevOfflineOverrideContext.Provider value={value}>
      {children}
    </DevOfflineOverrideContext.Provider>
  );
}

DevOfflineOverrideProvider.propTypes = {
  children: PropTypes.node,
};

/**
 * When DEV_OVERRIDE is enabled, returns the current override boolean;
 * otherwise returns undefined so production paths ignore the toggle.
 *
 * @param {boolean} devIsOffline
 * @returns {boolean | undefined}
 */
export const getDevIsOfflineOverride = (devIsOffline) =>
  DEV_OVERRIDE ? devIsOffline : undefined;

export { DEV_OVERRIDE };
